// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43f9150a","239":"e4c734bc","455":"73ff42f0"}[chunkId] + ".chunk.js";
};